import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

type Props = {
  date: any;
  setDate: (s: any) => void;
  disabledDates: any[];
  blockedDays: any;
};

const MastheadCampaignDatePicker = ({ date, setDate, disabledDates, blockedDays }: Props) => (
  <DatePicker
    bordered={false}
    style={{ width: '100%', padding: '0' }}
    value={date}
    onChange={(value) => {
      setDate(value);
    }}
    disabledDate={(day) =>
      day < moment().startOf('day') ||
      disabledDates.indexOf(moment(day).format('YYYY-MM-DD')) > -1 ||
      Object.prototype.hasOwnProperty.call(blockedDays, moment(day).format('dddd'))
    }
  />
);

export default MastheadCampaignDatePicker;
